    <div #main class="flex-col height100p">
        <sm-toolbar class="flex-item-fixed">
            <p-button icon="fas fa-cog" label="Config-Ordner an Zwischenablage" (onClick)="copyConfigToClipboard()"></p-button>
            <p-button *ngIf="devMode" icon="fas fa-cog" label="Config-Ordner an Dev" (onClick)="copyConfigToDev()"></p-button>
            <p-button *ngIf="devMode" icon="fas fa-cog" label="Update" (onClick)="getUpdate()"></p-button>
            <p-button *ngIf="devMode2" icon="fas fa-cog" label="Datei holen" (onClick)="getFile()"></p-button>
        </sm-toolbar>
        <div *ngIf="metaData != null"class="flex-item-fill flex-row-split">
            <div class="flex-item-fixed flex-col full-height width500">
                <sm-toolbar class="flex-item-fixed">
                    <p-button *ngIf="waitText == null" class="mr-2" icon="fas fa-cog" label="Update einspielen" (onClick)="runUpdate()"></p-button>
                    <p-button class="mr-2" icon="fas fa-times" label="Update abbrechen" (onClick)="cancelUpdate()"></p-button>
                    <p-message *ngIf="waitText != null" severity="danger" [text]="'Update muss warten: ' + waitText"></p-message>
                </sm-toolbar>
                <p-tree #tree class="flex-item-fill" selectionMode="checkbox" [value]="changesTree.items" [(selection)]="changesTree.selected" (onNodeSelect)="selectFile($event)" (onNodeUnselect)="selectFile($event)">
                </p-tree>
            </div>
            <div class="flex-item-fill height100p" >
                <div class="flex-row">
                    <div class="flex-110"><b>{{selFileLeft?.changeDateUtc | date:'dd.MM.yyyy HH:mm:ss'}}</b> (Alt) Auf diesem System</div>
                    <div class="flex-110"><b>{{selFileRight?.changeDateUtc | date:'dd.MM.yyyy HH:mm:ss'}}</b> (Neu) Aus dem Update</div>
                </div>
                <app-text-diff *ngIf="metaData != null" [fileName]="fileName" [left]="selFileLeft?.content ?? ''" [right]="selFileRight?.content ?? ''" leftFileName="(Alt) Auf diesem System" rightFileName="(Neu) Aus dem Update">
                </app-text-diff>
            </div>
    </div>
    <app-progressor-overlay [progressor]="progressor.value"></app-progressor-overlay>
</div>
